import { render, staticRenderFns } from "./EditOtherSupplier.vue?vue&type=template&id=22cdc226&scoped=true"
import script from "./EditOtherSupplier.vue?vue&type=script&lang=js"
export * from "./EditOtherSupplier.vue?vue&type=script&lang=js"
import style0 from "./EditOtherSupplier.vue?vue&type=style&index=0&id=22cdc226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cdc226",
  null
  
)

export default component.exports